import {
  FETCH_GDPI_STATUS_PENDING,
  FETCH_GDPI_STATUS_SUCCESS,
  FETCH_GDPI_STATUS_ERROR
} from "../action/gdpiStatusAction";

const initialState = {
  pending: false,
  gdpiStatus: [],
  error: null
};

const gdpiStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GDPI_STATUS_PENDING:
      return {
        ...state,
        pending: true
      };
    case FETCH_GDPI_STATUS_SUCCESS:
      return {
        ...state,
        pending: false,
        gdpiStatus: action.payload
      };
    case FETCH_GDPI_STATUS_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};
export default gdpiStatusReducer;
export const getGdpiStatus = state => state.gdpiStatus;
export const getGdpiStatusPending = state => state.pending;
export const getGdpiStatusError = state => state.error;
